import React from 'react';
import { Rating, Typography } from 'fronton-react';
import { TConfigurator } from '../../../../types';
import { NoPhoto } from '../no-photo';
import { CardWrapper, ContentWrapper } from '../styled';
import { useAnalytics } from '../hooks';
import { CardPrice } from '../card-price';
import { categoryCard, imgStyles, StyledDiv } from './styled';
import { useConfiguratorRating } from './hooks';

type InstallationCardProps = {
	configurator: TConfigurator;
	wide: boolean;
	position: number;
};

export const InstallationCard = ({ configurator, wide, position }: InstallationCardProps) => {
	const { name, pageUrl, price, imageUrl, measurementUnit, isPriceStatic } = configurator;
	const { ref, analyticsClickHandler } = useAnalytics(configurator);
	const { avgRating, ratingText, ratingClickHandler } = useConfiguratorRating({
		pageUrl,
		configurator,
		position,
	});

	return (
		<CardWrapper
			ref={ref}
			href={`${pageUrl}/`}
			className={categoryCard}
			data-qa="card"
			onClick={analyticsClickHandler}
			wide={wide}
		>
			{imageUrl ? (
				<img
					src={imageUrl}
					alt={name}
					className={imgStyles}
					data-qa="card-photo"
					data-analyticsName="productPhotoLink"
				/>
			) : (
				<NoPhoto />
			)}
			<ContentWrapper>
				<StyledDiv>
					<Typography
						variant="s"
						size="body_short"
						as="h3"
						data-qa="card-name"
						data-analyticsName="productNameLink"
					>
						{name}
					</Typography>
					<Rating size="s" value={avgRating} hasLink onClick={ratingClickHandler}>
						{ratingText}
					</Rating>
				</StyledDiv>
				<CardPrice price={price} unit={measurementUnit} flexiblePrice={!isPriceStatic} />
			</ContentWrapper>
		</CardWrapper>
	);
};
